import type { MappingTargetField } from '@/integration/importMappingCells';
import type { ImportFieldDescriptor } from '@/integration/onlineImport/onlineImportService';

/** The import adapter's fields — the list both mapping grids map against — as the cells read them. */
export function toMappingTargetFields(fields: ImportFieldDescriptor[]): MappingTargetField[] {
  return fields.map((f) => ({
    name: f.name,
    label: f.label,
    required: f.requiredOnCreate,
    isKey: f.isKey,
    serverAssigned: f.serverAssigned,
    referencedEntity: f.referencedEntity,
    referencedModule: f.referencedModule,
  }));
}
